module.exports = __webpack_public_path__ + "static/media/PADI-logo.daff6807.png";